import { createSlice } from "@reduxjs/toolkit";
// import { userListing } from "../Actions/AdminActions";
import { toast } from "react-toastify";
import {  getContactList, getEmergencyNumberData, getNotificationListing, getSupportListing, getUserProfile, userListing, workerVerification } from "../Actions/adminAction";

export const userMgmtSlice = createSlice({
  name: "userMgmtSlice",
  initialState: {
    userList: "",
    userdetails: "",
    workerDetails: "",
    notificationList: null,
    supportData: null,
    emergencyNumber: null,
    contactList: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userListing?.fulfilled, (state, action) => {
      if (action?.payload?.success) {
        state.userList = action.payload;
      } else {
        toast.error(action?.payload?.message);
      }
    });
    builder.addCase(getUserProfile?.fulfilled, (state, action) => {

      if (action?.payload?.success) {

        state.userdetails = action.payload;
      } else {
        toast.error(action?.payload?.message);
      }
    });
    builder.addCase(workerVerification?.fulfilled, (state, action) => {

      if (action?.payload?.success) {

        state.workerDetails = action.payload;
      } else {
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(getNotificationListing?.fulfilled, (state, action) => {

      if (action?.payload?.success) {

        state.notificationList = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(getSupportListing?.fulfilled, (state, action) => {

      if (action?.payload?.success) {

        state.supportData = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
    });


    builder.addCase(getEmergencyNumberData?.fulfilled, (state, action) => {

      if (action?.payload?.success) {

        state.emergencyNumber = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(getContactList?.fulfilled, (state, action) => {
      if (action?.payload?.success) {
        state.contactList = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
    });
  },
});

export default userMgmtSlice.reducer
